import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ children, adminOnly = false }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center">
        <div className="h-10 w-10 animate-spin rounded-full border-2 border-[#00F0FF] border-t-transparent" />
      </div>
    );
  }
  if (!user) return <Navigate to="/account" replace />;
  if (adminOnly && !["owner", "admin", "manager"].includes(user.role)) return <Navigate to="/" replace />;
  return children;
}
